import { render } from "./App.vue?vue&type=template&id=6472510a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6472510a&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_kh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__